export default function Title() {
  return (
    <div
      data-cy="wtb-title"
      className="flex items-center justify-between text-lg font-bold tracking-wide text-black"
    >
      Get notified when they release
    </div>
  );
}
